import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProfile } from "../../models/IProfile";
import { EnumLocalStorageKeys } from "../../enums/EnumLocalStorageKeys";
import { authApi } from "../../api/authApi";

interface authState {
	isAuth: boolean;
	profile: IProfile | null;
	isLoading: boolean;
}

const initialState: authState = {
	isAuth: false,
	profile: null,
	isLoading: false
};

export const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setIsAuth(state, action: PayloadAction<boolean>) {
			state.isAuth = action.payload;
		},
		setProfile(state, action: PayloadAction<IProfile>) {
			state.profile = action.payload;
		},
		setIsLoading(state, action: PayloadAction<boolean>) {
			state.isLoading = action.payload;
		},
		logout(state) {
			state.isAuth = false;
			state.profile = null;
            authApi.logout(localStorage.getItem(EnumLocalStorageKeys.token) as string).then(()=>{
                localStorage.removeItem(EnumLocalStorageKeys.token);
            })
			
		}
	}
});

export default authSlice.reducer;
